<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-container fluid>
    <b-row>
      <b-col>
        <div>
          <b-card header-tag="header">
            <template #header>
              <b-card-title class="seccionTitulo">
                <b-icon class="icono" icon="file-text"></b-icon>{{empresaActual.nombrePlan}}
              </b-card-title>
            </template> 
            <b-row>
              <b-col align="right">
                <b-button variant="outline-danger" v-on:click="regresar()">Regresar</b-button>
              </b-col>
            </b-row>
            <b-card-body>
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <b-card
                              header="Descripción"
                              header-tag="header"
                              title="">
                            <b-card-body class="scroll">
                              <b-card-text align="left">
                                <!--<p>Tipo de plan: {{empresaActual.nombreTipoPlan}}</p>-->
                                <span  v-html="empresaActual.descripcion"></span>
                              </b-card-text>
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-card
                              header="Requisitos"
                              header-tag="header"
                              title="">
                            <b-card-body>
                              <b-card-text align="left">
                                <span  v-html="empresaActual.requisitos"></span>
                              </b-card-text>
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col>
                      <b-row>
                        <b-col>
                          <b-card
                              header="Tratamientos y Descuentos"
                              header-tag="header"
                              title="">
                            <b-card-body class="scroll">
                              <label>Busqueda: </label>
                              <v-select
                              label="tratamiento"
                              id="idTratamiento"
                              v-model="tratamientoDescuentoBuscado"
                              :options="lstTratamientosDescuento"
                              @input="seleccionarBusquedatratamiento($event)">
                                <template #option="{tratamiento}">
                                  <label >{{ tratamiento}}</label>
                                </template>
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <br/>
                              <b-card-text>
                                <div align="left" >
                                  <b-list-group class="overflow-auto" flush>
                                    <b-list-group-item v-for="(tratamiento, index) of datosTablalstTratamientosDescuento" :key="index">
                                      {{tratamiento.descuento}}% - {{tratamiento.tratamiento}} <strong style="font-size: 13px">{{
                                        tratamiento.descuentoEspecial != null && tratamiento.descuentoEspecial > 0 ? " Descuento especial: " + tratamiento.descuentoEspecial + '%' + " (" + (tratamiento.vecesAnio != null ? tratamiento.vecesAnio : 1) + " al año)" : ""
                                      }}</strong>
                                    </b-list-group-item>
                                  </b-list-group>
                                </div>
                                <div align="center" v-if="loaderTratamientos">
                                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                                </div>
                                <div align="center" v-if="blnTratamientos">
                                  <b-alert show variant="warning">No se encontraron datos</b-alert>
                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-card
                              header="Grupos de tratamientos"
                              header-tag="header"
                              title="">
                            <b-card-body class="scroll">
                              <label>Busqueda: </label>
                              <v-select
                              label="nombreTratamiento"
                              id="idTratamiento"
                              v-model="tratamientoDescuentoGrupoBuscado"
                              :options="lstTratamientosDescuentoGrupo"
                              @input="seleccionarBusquedaGrupotratamiento($event)">
                                <template #option="{nombreTratamiento}">
                                  <label >{{ nombreTratamiento}}</label>
                                </template>
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <br/>


                              <b-card-text>
                                <div align="left" >
                                  <b-list-group class="overflow-auto" flush>
                                    <b-list-group-item v-for="(grupos, index) of datosTablalstTratamientosGrupoDescuento" :key="index">
                                      <div>{{grupos.descuento}}% - {{grupos.descripcion}} <strong style="font-size: 13px">{{
                                          grupos.precioEspecial != null && grupos.precioEspecial > 0 ? " Descuento especial: " + grupos.precioEspecial + '%' + " (" + (grupos.vecesAnio != null ? grupos.vecesAnio : 1) + " al año)" : ""
                                        }}</strong>
                                      </div>
                                      <div>Tratamientos: </div>
                                      <b-list-group class="overflow-auto" flush>
                                        <b-list-group-item v-for="(grupo, indice) of grupos.tratamientoGrupoTratamientoDTOS" :key="indice">
                                          <div>Tratamiento: {{grupo.nombreTratamiento}}</div>
                                        </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                    <hr>
                                  </b-list-group>
                                </div>
                                <div align="center" v-if="loaderGrupoTratamiento">
                                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                                </div>
                                <div align="center" v-if="blnGrupos">
                                  <b-alert show variant="warning">No se encontraron datos</b-alert>
                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row><b-col><br></b-col></b-row>
                  <b-row>
                      <b-col align="right">
                        <b-button variant="outline-danger" v-on:click="regresar()">Regresar</b-button>
                        <br/><br/><br/>
                        <br/><br/><br/>
                      </b-col>
                    </b-row>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>

export default {
name: "detalle",
  components:{
  },
  props:{
    empresaActual: null
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    blnTratamientos:false,
    blnGrupos:false,
    loaderTratamientos:false,
    loaderGrupoTratamiento:false,
    lstTratamientosDescuento:[],
    lstGruposTratamientos:[],
    datosTablalstTratamientosDescuento : [],
    datosTablalstTratamientosGrupoDescuento : [],
    tratamientoDescuentoBuscado: null,
    tratamientoDescuentoGrupoBuscado : null,
    lstTratamientosDescuentoGrupo : [],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    if(this.empresaActual !== null){
      this.empresa = this.empresaActual;
      this.obtenerTratamientosDescuentos(this.empresaActual);
      this.obtenerGrupoTratamientos(this.empresaActual);
    }
  },
  methods:{
    regresar(){
      this.$emit('regresar', 'cerrar');
    },
    /**
     * Funcion para obtener los tratamientos descuentos
     * @param empresa
     */
    obtenerTratamientosDescuentos(empresa){
      this.loaderTratamientos = true;
      const parametros = {idPlan: empresa.idPlan}
      this.$http.post(this.$api + "empresas/obtener/tratamientos/descuento", parametros).then(response => {
        this.loaderTratamientos = false;
        if (response.data.data){
          let resultado = response.data.data;
          this.lstTratamientosDescuento = [];
          this.datosTablalstTratamientosDescuento = [];
          resultado.forEach((item, index) =>{
            item.id = index;
            this.lstTratamientosDescuento.push(item);
            this.datosTablalstTratamientosDescuento.push(item);
          });
        }
        if(this.lstTratamientosDescuento.length <= 0){
          this.blnTratamientos = true;
        }
      }).catch(function (error) {
        this.loaderTratamientos = false;
        console.error(error);
      });
    },
    /**
     * Funcion para obtener los grupos de tratamietos
     * @param empresa
     */
    obtenerGrupoTratamientos(empresa){
      this.loaderGrupoTratamiento = true;
      const parametros = {idPlan: empresa.idPlan}
      this.$http.post(this.$api + "empresas/obtener/grupos/tratamientos", parametros).then(response => {
        this.loaderGrupoTratamiento = false;
        if (response.data.data){
          let resultado = response.data.data;
          this.lstGruposTratamientos = [];
          this.datosTablalstTratamientosGrupoDescuento = [];
          resultado.forEach((item, index) =>{
            item.id = index;
            this.lstGruposTratamientos.push(item);
            this.datosTablalstTratamientosGrupoDescuento.push(item);
          });
        }
        if(this.lstGruposTratamientos.length <= 0){
          this.blnGrupos = true;
        }
        this.buscadorSelectGrupos();
      }).catch(function (error) {
        this.loaderGrupoTratamiento = false;
        console.error(error);
      });
    },


    seleccionarBusquedatratamiento(tratamiento) {
      this.datosTablalstTratamientosDescuento = [];
      if(tratamiento == null){
          this.datosTablalstTratamientosDescuento = this.lstTratamientosDescuento;
      } else {
        this.lstTratamientosDescuento.forEach((element) => {
          if (element.idTratamiento == tratamiento.idTratamiento ) {
            this.datosTablalstTratamientosDescuento.push(element);
          }
        });
      }
    },

    buscadorSelectGrupos(){
      if(this.lstGruposTratamientos.length > 0){
        this.lstTratamientosDescuentoGrupo = [];
         this.lstGruposTratamientos.forEach((item) =>{
            item.tratamientoGrupoTratamientoDTOS.forEach((datos) =>{
              this.lstTratamientosDescuentoGrupo.push(datos);
            });
          });
      }
    },
    seleccionarBusquedaGrupotratamiento(tratamiento){
      this.datosTablalstTratamientosGrupoDescuento = [];
      if(tratamiento == null){
          this.datosTablalstTratamientosGrupoDescuento = this.lstGruposTratamientos;
      } else {
        this.lstGruposTratamientos.forEach((element) => {

            element.tratamientoGrupoTratamientoDTOS.forEach((datos) =>{
              if(datos.idTratamiento == tratamiento.idTratamiento){
                this.datosTablalstTratamientosGrupoDescuento.push(element);
              }


            });




        });
      }
    },




  }
}
</script>

<style scoped>

</style>
